import  * as React from "react";
import { observer } from "mobx-react";
import { IOptimizerViewButtonsParams } from "./IOptimizerViewButtonsParams";

@observer
export class OptimizerViewButtons extends React.Component<IOptimizerViewButtonsParams>{
    constructor(props: IOptimizerViewButtonsParams) {
        super(props, undefined);
        this.selectOptimizerView = this.selectOptimizerView.bind(this);
    }

    selectOptimizerView(name: string): void {
        this.props.selectOptimizerView(name);
    }

    render() {
        let isDataButtonSelected = this.props.selectedOptimizerView === 'Data' ? 'selected-optimizer-view': '';
        let isTrajectoryButtonSelected = this.props.selectedOptimizerView === 'Trajectory' ? 'selected-optimizer-view' : '';
        return <div className="OptimizerViewButtons col-xs-4 optimizer-view-details">
                   <div className="view-type-text"><span>View</span>
                   </div>
                   <div className="optimizer-view-buttons">
                       <div className={isDataButtonSelected} onClick={() => { this.selectOptimizerView('Data') }}>Data</div>
                       <div className={isTrajectoryButtonSelected} onClick={() => { this.selectOptimizerView('Trajectory') }}>Trajectory</div>
                   </div>
               </div>;
    }
}
